export default __webpack_public_path__ + "static/media/fridge-freezer-gray.8683676e.svg";